import React from "react";

import { Typography } from "../../Typography";
import { WizardStepperStepProps } from "../types";
import * as S from "./Step.styles";

/**
 * Individual step in the wizard
 */
export const Step = ({ step, hasLabel, onClick }: WizardStepperStepProps) => {
  return (
    <S.WizardStep hasLabel={hasLabel} status={step.status} onClick={onClick}>
      <S.StepNumber>{step.number}</S.StepNumber>
      {hasLabel && <Typography.Label>{step.label}</Typography.Label>}
    </S.WizardStep>
  );
};
